import {ColorModeScript, ChakraProvider, extendTheme} from "@chakra-ui/react";
import * as ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import Fonts from "./components/Fonts";
import {AuthProvider, ChatProvider, RequestProvider, VerificationProvider} from "./context";

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(container);

const theme = extendTheme({
    fonts: {heading: `'Inter', sans-serif`, body: `'Inter', sans-serif`},
    colors: {
        error: "#ff3333",
        primary: {100: "#79a0a0", 500: "#017172", 900: "#003a3b"},
        dark: {100: "#8C8C8C", 200: "#1F1F1F", 500: "#454545", 900: "#454545"},
        grey: {
            100: "#EBEEF2",
            150: "#AEAEAE",
            200: "#D9D9D9",
            300: "#EBEEF2",
            500: "#8C8C8C",
        },
        customBlue: {100: "#E9EFFD", 500: "#0A53BF", 900: "#0A53BF"},
        customOrange: {100: "#FDF1EA", 500: "#EA702E", 900: "#EA702E"},
    },
    fontSizes: {base: "16px", xs: "16px", sm: "16px", md: "16px"}
});

root.render(
    <ChakraProvider theme={theme}>
        <Fonts />
        <ColorModeScript />
        <AuthProvider>
            <VerificationProvider>
                <RequestProvider>
                    <ChatProvider><App/></ChatProvider>
                </RequestProvider>
            </VerificationProvider>
        </AuthProvider>
    </ChakraProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();
